import request from '@/utils/request';

function transformDto2Item(dto) {
  const item = {
    code: dto.code,
    id: dto.optionID,
    description: dto.description
  };
  return item;
}
export function apiFetchList(code) {
  return request({
    method: 'get',
    url: '/option/' + code
  });
}
export const apiOverrides = { transformDto2Item, apiFetchList };

export const storeExtensions = {
  actions: {
    update({ commit }, item) {
      throw new Error('Options are not updatable');
    },
    create({ commit }, item) {
      throw new Error('Options are not creatable');
    },
    delete({ commit }, item) {
      throw new Error('Options are not deletable');
    },
    fetchOptions({ commit, dispatch, state }, code) {
      dispatch('getItems', code).then(() => {
        commit('UPDATE_OPTIONS', code);
      });
    }
  },
  mutations: {
    UPDATE_OPTIONS: (state, code) => {
      const loadedOptions = {};
      loadedOptions[code] = state.items;
      state.options = Object.assign({}, state.options, loadedOptions);
    }
  },
  getters: {
    loadedOptions: state => code => {
      return state.options[code];
    }
  },
  state: {
    options: {}
  }
};
